import axios from "axios";
import api from "../../utils/axios";
import { CLIENT_MESSAGING_SETTINGS_ENDPOINTS } from "./endpoints";
import {
	ClientMessagingOptions,
	ClientMessagingSettings,
	ClientMessagingSettingsError,
	UpdateClientMessagingSettingsRequest,
	UpdateClientMessagingSettingsResponse,
} from "./types";

export const getClientMessagingOptions =
	async (): Promise<ClientMessagingOptions> => {
		const response = await api.get<ClientMessagingOptions>(
			CLIENT_MESSAGING_SETTINGS_ENDPOINTS.options
		);
		return response.data;
	};

/** Settings of the given clients, sent as `?sellerIds=1&sellerIds=2`. */
export const getClientMessagingSettings = async (
	sellerIds: number[]
): Promise<ClientMessagingSettings[]> => {
	const response = await api.get<ClientMessagingSettings[]>(
		CLIENT_MESSAGING_SETTINGS_ENDPOINTS.settings,
		{ params: { sellerIds }, paramsSerializer: { indexes: null } }
	);
	return response.data;
};

/**
 * All listed clients take the change, or none do. A 400 carries each client's reasons — read them
 * with {@link readClientErrors}; the axios interceptor already toasts the general message.
 */
export const updateClientMessagingSettings = async (
	body: UpdateClientMessagingSettingsRequest
): Promise<UpdateClientMessagingSettingsResponse> => {
	const response = await api.put<UpdateClientMessagingSettingsResponse>(
		CLIENT_MESSAGING_SETTINGS_ENDPOINTS.settings,
		body
	);
	return response.data;
};

/** The per-client reasons from a rejected update, flattened; empty for any other error. */
export const readClientErrors = (error: unknown): string[] => {
	if (!axios.isAxiosError(error)) return [];

	const body = error.response?.data as
		| Partial<ClientMessagingSettingsError>
		| undefined;
	return body?.sellers?.flatMap((seller) => seller.errors) ?? [];
};
